export const config = {
    api: process.env.REACT_APP_WEDDING_API,
    api_key: process.env.REACT_APP_API_KEY
};
